import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FinancialAidIndicatorService from "../../src/Services/FinancialAidIndicator.service";
import LookupGeneric from "./lookupGeneric";
const FinancialAidIndicatorLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            return FinancialAidIndicatorService.findByIds(ids).then(({ data }) => data);
        },
        fetchOptions: (value) => {
            return FinancialAidIndicatorService.search({
                value,
                active: true,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(financialAidIndicator) {
            return _jsx("span", { children: financialAidIndicator.value });
        },
    });
};
export default FinancialAidIndicatorLookup;
